import { generateTimeValues } from "src/utils";

export const timeValues = generateTimeValues("30");

export const defaultTimeValue = timeValues[19]; // 9:30 AM

